export default class VersionNotificationFilter {
  constructor() {
    this.id = ''
    this.platform = ''
    this.version = ''
    this.mode = ''
    this.titleNotification = ''
    this.messageNotification = ''
    this.storeButtonLabel = ''
    this.dismissButtonLabel = ''
    this.closeButtonLabel = ''
    this.exactType = { id: '1', platform: '1', version: '0', mode: '1', titleNotification: '0', messageNotification: '0', storeButtonLabel: '0', dismissButtonLabel: '0', closeButtonLabel: '0' }
  }
}
